import React, { useState, useEffect } from "react";
import {
  FaTrophy, FaGamepad, FaChartLine, FaListOl, FaHome, FaBars,
  FaUsers, FaScroll, FaCog, FaNewspaper
} from "react-icons/fa";

import logo from "../img/COBRADOR_LEAGUE_LOGO_02_FINAL.png";
import vortem from "../img/vortem4.png";

import { useLeaderboard } from "../hooks/useLeaderboard";
import { usePlayerMatches } from "../hooks/usePlayerMatches";
import { getArmyIcon } from "../util/getArmyIcon";
import { useLocation } from "react-router-dom";

// ⭐ USAMOS TU COMPONENTE HEADER
import Header from "./components/Header";

const LeagueDashboard = () => {
  const location = useLocation();
  const [idleague, setIdleague] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get("idleague");
    setIdleague(id ? parseInt(id) : 1);
  }, [location]);

  const { divisions } = useLeaderboard(idleague);

  const [selectedPlayers, setSelectedPlayers] = useState({});
  const [playerMatchesMap, setPlayerMatchesMap] = useState({});
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Fase I");
  const [currentDivisionId, setCurrentDivisionId] = useState(null);

  const [playerId, setPlayerId] = useState(null);
  const { matches, loading, error } = usePlayerMatches(playerId, idleague);

  const handlePlayerClick = (divisionId, player) => {
    setSelectedPlayers(prev => ({ ...prev, [divisionId]: player }));
    setCurrentDivisionId(divisionId);
    setPlayerId(player.idplayer);
  };

  useEffect(() => {
    if (currentDivisionId && selectedPlayers[currentDivisionId]) {
      setPlayerMatchesMap(prev => ({ ...prev, [currentDivisionId]: matches }));
    }
  }, [matches, currentDivisionId, selectedPlayers]);

  const tabs = [
    { label: "Fase I", phase: 1 },
    { label: "Fase II-a", phase: 2 },
    { label: "Fase II-b", phase: 3 },
    { label: "Play-off", phase: 4 }
  ];

  const renderDivision = (division) => {
    const selected = selectedPlayers[division.division];
    const divisionMatches = playerMatchesMap[division.division] || [];

    return (
      <div key={division.division}>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-stretch">
          
          {/* TABLA DE LA DIVISIÓN */}
          <div className="lg:col-span-3 h-full">
            <div className="bg-gray-800 rounded-lg shadow-lg p-6">
              <h2 className="text-2xl font-bold mb-4 text-center text-white">
                {division.division}
              </h2>
              <div className="overflow-x-auto">
                <table className="w-full table-fixed">
                  <thead>
                    <tr className="bg-gray-700">
                      <th className="w-12 px-4 py-2 text-center">Pos</th>
                      <th className="w-24 px-4 py-2 text-left">Player</th>
                      <th className="w-32 px-4 py-2 text-left">Name</th>
                      <th className="w-12 px-4 py-2 text-center">GP</th>
                      <th className="w-12 px-4 py-2 text-center">W</th>
                      <th className="w-12 px-4 py-2 text-center">L</th>
                      <th className="w-12 px-4 py-2 text-center">D</th>
                      <th className="w-12 px-4 py-2 text-center">PS</th>
                      <th className="w-12 px-4 py-2 text-center">PC</th>
                      <th className="w-12 px-4 py-2 text-center">TP</th>
                    </tr>
                  </thead>
                  <tbody>
                    {division.players.map((player, index) => (
                      <tr
                        key={player.idplayer}
                        className="hover:bg-gray-700 transition-colors duration-200 cursor-pointer"
                        onClick={() => handlePlayerClick(division.division, player)}
                      >
                        <td className="px-4 py-2 text-center">{index + 1}</td>
                        <td className="px-4 py-2">{player.nick}</td>
                        <td className="px-4 py-2 text-gray-500">{player.player}</td>
                        <td className="px-4 py-2 text-center">{player.played}</td>

                        <td className={player.won > 0 ? "text-green-500 px-4 py-2 text-center" : "px-4 py-2 text-center"}>
                          {player.won}
                        </td>

                        <td className={player.lost > 0 ? "text-red-500 px-4 py-2 text-center" : "px-4 py-2 text-center"}>
                          {player.lost}
                        </td>

                        <td className="px-4 py-2 text-center">{player.drawn}</td>
                        <td className="px-4 py-2 text-center">{player.score}</td>
                        <td className="px-4 py-2 text-center">{player.counterscore}</td>
                        <td className="px-4 py-2 text-center font-semibold">{player.points}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* PARTIDOS DEL JUGADOR */}
          <div className="lg:col-span-2 h-full">
            <div className="bg-gray-800 rounded-lg shadow-lg p-6 h-full overflow-y-auto">
              <h2 className="text-2xl font-semibold mb-4">Player Matches</h2>

              {selected ? (
                loading ? (
                  <p className="text-gray-400">Cargando partidas...</p>
                ) : error ? (
                  <p className="text-red-400">Error al cargar partidas.</p>
                ) : (
                  <div className="rounded-lg bg-gray-800 p-2 shadow-lg">
                    <div className="space-y-2 max-h-[600px] overflow-y-auto">
                      {divisionMatches.length > 0 ? (
                        divisionMatches.map((match) => {
                          const ArmyIconP1 = getArmyIcon(match.army_p1);
                          const ArmyIconP2 = getArmyIcon(match.army_p2);

                          return (
                            <div
                              key={match.id}
                              className="grid grid-cols-[1fr_1fr_0.5fr_0.5fr_0.5fr_1fr_1fr] items-center rounded-lg bg-gray-700 p-2 text-center gap-x-1"
                            >
                              <div>
                                {ArmyIconP1 && <img src={ArmyIconP1} alt="Army 1 Icon" className="w-10 h-10 mx-auto" />}
                              </div>

                              <div className="text-right text-white">
                                {match.nick1}
                                <br />
                                <p className="text-gray-500 text-sm">{match.army_p1}</p>
                              </div>

                              <div
                                className={
                                  (match.score_p1 > match.score_p2
                                    ? "text-green-300"
                                    : match.score_p1 < match.score_p2
                                    ? "text-red-300"
                                    : "") + " text-xl font-bold text-right"
                                }
                              >
                                {match.score_p1}
                              </div>

                              <div className="text-white col-span-1 flex justify-center">vs</div>

                              <div
                                className={
                                  (match.score_p2 > match.score_p1
                                    ? "text-green-300"
                                    : match.score_p2 < match.score_p1
                                    ? "text-red-300"
                                    : "") + " text-xl font-bold text-left"
                                }
                              >
                                {match.score_p2}
                              </div>

                              <div className="text-left text-white">
                                {match.nick2}
                                <br />
                                <p className="text-gray-500 text-sm">{match.army_p2}</p>
                              </div>

                              <div>
                                {ArmyIconP2 && <img src={ArmyIconP2} alt="Army 2 Icon" className="w-10 h-10 mx-auto" />}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <p className="text-gray-400">No hay partidas para este jugador.</p>
                      )}
                    </div>
                  </div>
                )
              ) : (
                <p className="text-gray-400">Haz clic en un jugador para ver sus partidas.</p>
              )}
            </div>
          </div>

        </div>

        <br /><br />
      </div>
    );
  };

  const filteredDivisions = divisions.filter((division) => {
    const tab = tabs.find(t => t.label === activeTab);
    return tab && tab.phase === 1 ? true : division.phase === tab.phase;
  });

  return (
    <div className="flex flex-col min-h-screen bg-gray-900 text-white">
      
      {/* ⭐ NUEVO HEADER COMPONENT */}
      <Header
        logo={logo}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        idleague={idleague}
      />

      {/* INTRO */}
      <div className="w-full flex flex-row items-start p-4 space-x-4">
        <div className="w-1/3">
          <img src={vortem} alt="El Cobrador League Logo" className="w-full h-80 object-contain" />
        </div>

        <div className="w-2/3 h-80 bg-gray-800 rounded-lg shadow-lg p-4 flex flex-col items-center">
          <h2 className="text-white text-2xl font-bold mb-2">
            El Velo de Sangre: Crónicas del Subsector Vortem
          </h2>
          <p className="text-white text-lg font-normal">
            `El Subsector Vortem, antaño una región próspera del Segmentum Obscurus, ha sido desgarrado por la aparición de una grieta disforme conocida como el Velo de Sangre. Esta anomalía, surgida tras una tormenta warp sin precedentes, ha alterado la realidad misma en varios sistemas planetarios, provocando mutaciones, desapariciones masivas y el colapso de las comunicaciones astropáticas.

El Imperio ha declarado el subsector como Zona de Guerra Prioritaria, pero sus fuerzas están fragmentadas. Mientras tanto, otras facciones han detectado la inestabilidad y han acudido con sus propias agendas: algunos buscan poder, otros venganza, otros simplemente sobrevivir.

El conflicto no es solo militar: es espiritual, ideológico y existencial. El Velo de Sangre no solo distorsiona la materia, sino también la voluntad. Las alianzas se rompen, los líderes enloquecen, y los planetas cambian de manos en cuestión de días.`
          </p>
        </div>
      </div>

      {/* TABS */}
      <div className="flex justify-center mt-4 space-x-4">
        {tabs.map(tab => (
          <button
            key={tab.label}
            onClick={() => setActiveTab(tab.label)}
            className={`px-4 py-2 rounded ${
              activeTab === tab.label ? 'bg-white text-black font-bold' : 'bg-gray-700 text-white'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* CONTENIDO DE LAS DIVISIONES */}
      <div className="flex-grow p-8">
        {Array.isArray(filteredDivisions) && filteredDivisions.map(renderDivision)}
      </div>
    </div>
  );
};

export default LeagueDashboard;
